<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-table height="calc(100% - 6rem)" :data="beautyStaffs" show-header style="width: 100%" @row-click="openBeautyHead">
            <el-table-column prop="staffname" align="center" label="员工姓名"></el-table-column>
            <el-table-column prop="islooksay" align="center" label="负责客量">
                <template slot-scope="scope">
                    {{scope.row.islooksay}}({{scope.row.days}})
                </template>
            </el-table-column>
            <el-table-column prop="islooksay" align="center" label="目标/到店">
                <template slot-scope="scope">
                    {{scope.row.gl}}({{scope.row.isgeneral}})
                </template>
            </el-table-column>
            <el-table-column prop="stafftype" align="center" label="新客">

            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                beautyStaffs:[],
                storeid:localStorage.getItem("storeid"),
                brands:[],
            }
        },
        created: function () {
            this.getBeautyDeptCardHeadInfo();
            this.getStoreInfoByStructsOpen();
        },
        methods: {
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getBeautyDeptCardHeadInfo();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            openBeautyHead(row){
                this.$router.push({path:"/beautyheadstaff",query:{
                    staffid:row.staffid,
                }});
            },
            getBeautyDeptCardHeadInfo(){
                this.$post("beautymanager/getBeautyDeptCardHeadInfo",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.beautyStaffs=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/beauty/storebeautyhead.vue